module.exports = __webpack_public_path__ + "img/CheckboxGroup.29198f24.svg";